import Logo from '../../../views/common/icons/Logo';
import styles from './mobileHeader.module.scss';
import { useAppSelector } from '../../../redux/store';
import { isAuth } from '../../../utils/tokenServices';
import { useGetPublicServicesQuery } from '../../../redux/api/serviceApi';
import SearchBar from '../searchBar/SearchBar.tsx';
import Notifications from '../notifications/Notifications';
import cn from 'classnames';
import { useState } from 'react';
import MobileUserDropDown from './MobileUserDropdown';
import { USERS_API_URL } from '../../../constants';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import MenuOpenOutlinedIcon from '@mui/icons-material/MenuOpenOutlined';
import PinnedShortcuts from '../shortcuts/PinnedShortcuts.tsx';
import { useTranslation } from 'react-i18next';
import IfxButton from '../../../views/common/IfxButton.tsx';

export const MobileHeaderComponent = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'userDropdown' });
  const services = useAppSelector(state => state.layout.servicesList);
  const isAuthenticated = isAuth();
  const { data: publicServices = [] } = useGetPublicServicesQuery(undefined, { skip: isAuthenticated });
  const [isOpen, setIsOpen] = useState(false);

  const handleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  const onLogin = () => {
    window.location.href = `${USERS_API_URL}/sso/redirect`;
  };

  return (
    <header className={styles.header}>
      <div className={styles.mobileHeader}>
        <div className={styles.headerContainer}>
          <a href="/">
            <Logo />
          </a>
          <SearchBar
            services={isAuthenticated ? services : publicServices}
            onOpen={closeSidebar}
            isAuthenticated={isAuthenticated}
          />
          <div className={styles.wrapperBurger}>
            {!isAuthenticated && (
              <div>
                <IfxButton variant="text" className={styles.userLogin} onClick={onLogin} autoFocus>
                  <PersonOutlineOutlinedIcon className={styles.iconUser} />
                  <div className={styles.text}>{t('login')}</div>
                </IfxButton>
              </div>
            )}
            {isAuthenticated && (
              <>
                {isAuthenticated && <PinnedShortcuts onOpen={closeSidebar} />}
                <Notifications onOpen={closeSidebar} />
                <div data-testid="burger-button" onClick={handleSidebar}>
                  <IfxButton
                    variant="text"
                    autoFocus
                    data-testid="open-button"
                    className={cn(styles.burgerIcon, { [styles.hide]: isOpen })}
                  >
                    <MenuOpenOutlinedIcon />
                  </IfxButton>
                  <IfxButton
                    variant="text"
                    autoFocus
                    data-testid="close-button"
                    className={cn(styles.burgerIcon, { [styles.hide]: !isOpen })}
                  >
                    <CloseOutlinedIcon />
                  </IfxButton>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className={cn(styles.burgerMenu, { [styles.open]: isOpen })}>
        <MobileUserDropDown isOpen={isOpen} handleSidebar={handleSidebar} />
      </div>
    </header>
  );
};

const MobileHeader = () => {
  return <MobileHeaderComponent />;
};

export default MobileHeader;
